const STATUS_TEXT = Object.freeze({
  NO_STATE: "Select A Reason",
  COMPLETE: "Complete",
  WATCH: "Watch",
  PROBLEM: "Problem",
  SKIP: "Skip",
});

const STATUS_NUMBER_TO_TEXT = Object.freeze({
  0: STATUS_TEXT.NO_STATE,
  1: STATUS_TEXT.COMPLETE,
  2: STATUS_TEXT.WATCH,
  3: STATUS_TEXT.PROBLEM,
  4: STATUS_TEXT.SKIP,
});

const DEFAULT_STATUS = 0;

module.exports = {
  STATUS_TEXT,
  STATUS_NUMBER_TO_TEXT,
  DEFAULT_STATUS,
  getStatusText: (statusNumber) =>
    statusNumber in STATUS_NUMBER_TO_TEXT
      ? STATUS_NUMBER_TO_TEXT[statusNumber]
      : STATUS_TEXT.NO_STATE,
};
